import React, { useState } from "react";
import { FiLink2 } from "react-icons/fi";
import { isFunction } from "lodash";

import "./ClipboardCopy.scss";

interface ClipboardCopyProps {
  copyText?: string;
  onClick?: () => void;
}

function ClipboardCopy({ copyText, onClick }: ClipboardCopyProps) {
  const [isCopied, setIsCopied] = useState(false);

  async function copyTextToClipboard(text?: string) {
    if ("clipboard" in navigator) {
      return await navigator.clipboard.writeText(text as string);
    } else {
      return document.execCommand("copy", true, text);
    }
  }

  const handleCopyClick = () => {
    copyTextToClipboard(copyText)
      .then(() => {
        setIsCopied(true);
        if (isFunction(onClick)) {
          onClick();
        }
        setTimeout(() => {
          setIsCopied(false);
        }, 1500);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    // `value` is not a valid <div> attribute, but it was present on the original
    // JS component; preserved verbatim to avoid a behavior change.
    // @ts-expect-error -- non-standard `value` attr on a div, kept as-is
    <div className="link-box" value={copyText}>
      <span className="link" onClick={handleCopyClick}>
        <FiLink2 className="icon" color="white" stroke="#60A4BF" size={16} />
        <p className="link-text">{isCopied ? "Copied!" : "Copy Link"}</p>
      </span>
    </div>
  );
}

export default ClipboardCopy;
